var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgFullscreenOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "TOL-fullscreen_x5F_off_x5F_24",
    d: "M3,7H2V2h5v1H3V7z M3,17H2v5h5v-1H3V17z M6.8,15.8l-2.5,2.5l1.4,1.4l2.5-2.5L10,19v-5H5 L6.8,15.8z M17.2,8.2l2.5-2.5l-1.4-1.4l-2.5,2.5L14,5v5h5L17.2,8.2z M21,21h-4v1h5v-5h-1V21z M17,2v1h4v4h1V2H17z M5.7,4.3L4.3,5.7 l2.5,2.5L5,10h5V5L8.2,6.8L5.7,4.3z M19.7,18.3l-2.5-2.5L19,14h-5v5l1.8-1.8l2.5,2.5L19.7,18.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFullscreenOff);
export default __webpack_public_path__ + "static/media/img_Fullscreen_off.7671d3c14d16d4fae0a3aaba13f13b9b.svg";
export { ForwardRef as ReactComponent };